import { Link } from "expo-router";
import React from "react";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { useResponsive } from "../live-chat/useResponsive";
import { AppleAppStoreButton } from "./AppleAppStoreButton";
import { GooglePlayStoreButton } from "./GooglePlayStoreButton";

export function StoreButtons() {
  const r = useResponsive();
  return (
    <View
      flexDirectionRow
      style={{ width: "100%" }}
      paddingHorizontalSmall={r(true, false, false)}
    >
      <View flex>
        <View centerContent>
          <Spacer extraLarge />
          <Text sizeLarge weightSemiBold alignCenter>
            {intl.formatMessage({
              id: "Y2mwra",
              defaultMessage:
                "Download the BokBok dating app on Google Play or Apple App Store",
              description:
                "Download the BokBok dating app on Google Play or Apple App Store",
            })}
          </Text>

          <Spacer medium />

          <View
            flexDirectionRow
            centerContent
            style={{ gap: styleConstants.spacingMedium }}
          >
            <Link
              href="https://play.google.com/store/apps/details?id=bokbok.dating.app"
              target="_blank"
              aria-label={intl.formatMessage({
                defaultMessage: "Button Get It On Google Play",
                description: "Button aria-label",
                id: "I8Xq/b",
              })}
            >
              <GooglePlayStoreButton size={r(171, 190, 220)} />
            </Link>

            <Link
              href="https://apps.apple.com/us/app/bokbok-dating-app/id6470671279"
              target="_blank"
              aria-label={intl.formatMessage({
                defaultMessage: "Download on the App Store",
                description: "Button aria-label",
                id: "/041/x",
              })}
            >
              <AppleAppStoreButton size={r(151.2, 168, 194.52)} />
            </Link>
          </View>
          <Spacer extraLarge />
        </View>
      </View>
    </View>
  );
}
